module.exports = __webpack_public_path__ + "static/media/0601icon.52831152.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/0601icon.jpg
// module id = 400
// module chunks = 0